import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { observable, computed, action, flow } from 'mobx';
import _get from 'lodash/get';
import { mapInitialStateToStoreState } from "../../utils/store.utils/index.js";
import { API_STATE } from "../../constants/index.js";
import { LoyaltyClient } from "../../clients/loyalty.client.js";
var INITIAL = API_STATE.INITIAL,
  LOADING = API_STATE.LOADING,
  SUCCESS = API_STATE.SUCCESS,
  FAILED = API_STATE.FAILED;
/**
 * Fursan Store for a single package
 */
export var FursanStore = (_dec = action.bound, (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function FursanStore(initialState, $env) {
    if (initialState === void 0) {
      initialState = {};
    }
    if ($env === void 0) {
      $env = {};
    }
    this.$env = void 0;
    _initializerDefineProperty(this, "data", _descriptor, this);
    _initializerDefineProperty(this, "API_STATE", _descriptor2, this);
    /**
     * fetch reward points
     * @param {Object} prop
     * @param {Object} prop.payload
     * @param {Function} prop.errorHandler
     */
    _initializerDefineProperty(this, "fetch", _descriptor3, this);
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  var _proto = FursanStore.prototype;
  /**
   * update initial state
   * @param {Object} initialState
   */
  _proto.updateInitialState = function updateInitialState(initialState) {
    mapInitialStateToStoreState(this, initialState);
  };
  /**
   * handle success
   * @param {Object} data
   */
  _proto.onSuccess = function onSuccess(data) {
    this.data = data;
    this.API_STATE = SUCCESS;
  }

  /**
   * handle error
   * @param {Object} error
   * @param {Function} errorHandler
   */;
  _proto.onError = function onError(error, errorHandler) {
    this.API_STATE = FAILED;
    errorHandler(error);
  };
  _createClass(FursanStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function get() {
      return this.API_STATE === LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function get() {
      return this.API_STATE === SUCCESS;
    }

    /**
     * has error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function get() {
      return this.API_STATE === FAILED;
    }

    /**
     * reward value
     * @return {number}
     */
  }, {
    key: "rewardValue",
    get: function get() {
      return _get(this.data, 'rewardValue', 0);
    }

    /**
     * can earn
     * @return {boolean}
     */
  }, {
    key: "canEarn",
    get: function get() {
      return this.rewardValue > 0;
    }

    /**
     * can earn test
     * @return {boolean}
     */
  }, {
    key: "canEarnTest",
    get: function get() {
      return this.rewardValue > 0;
    }
  }]);
  return FursanStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "data", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "API_STATE", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return INITIAL;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFetched", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rewardValue", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "rewardValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEarnTest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canEarnTest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateInitialState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fetch", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return flow(function fetch(_ref) {
      var _this = this;
      var payload = _ref.payload,
        _ref$errorHandler = _ref.errorHandler,
        errorHandler = _ref$errorHandler === void 0 ? function () {
          return null;
        } : _ref$errorHandler;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.API_STATE = LOADING;
              _context.prev = 1;
              _context.next = 4;
              return LoyaltyClient.calculateFursanRewards(payload);
            case 4:
              response = _context.sent;
              _this.onSuccess(response);
              _context.next = 11;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              _this.onError(_context.t0, errorHandler);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 8]]);
      })();
    });
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype)), _class));